import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const BurkinaFasoFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14441'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14441)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V7.46667H0V14Z'
					fill='#00B051'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 7.46667H20V0H0V7.46667Z'
					fill='#FA494B'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99972 8.55863L8.32033 9.73187L8.93997 7.80407L7.28242 6.60138L9.34476 6.58318L9.99972 4.66663L10.6547 6.58318L12.717 6.60138L11.0595 7.80407L11.6791 9.73187L9.99972 8.55863Z'
					fill='#FDD216'
				/>
			</g>
		</svg>
	);
};

export default BurkinaFasoFlagIcon;
